<template>
  <section class="responsive-filters">
    <button
      type="button"
      class="responsive-filters__toggle"
      :aria-expanded="open.toString()"
      @click="open = !open"
    >
      <span><i class="fas fa-filter" aria-hidden="true"></i> {{ label }}</span>
      <i :class="open ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" aria-hidden="true"></i>
    </button>
    <div v-show="open" class="responsive-filters__content">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: "ResponsiveFilters",
  props: {
    label: { type: String, default: "Filtros" },
  },
  data() {
    return { open: false };
  },
  mounted() {
    this.open = false;
  },
};
</script>

<style lang="scss" scoped>
.responsive-filters__toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 44px;
  padding: 0.65rem 0.9rem;
  color: #00758f;
  font: inherit;
  font-weight: 700;
  background: #f8fbfc;
  border: 1px solid #dcecef;
  border-radius: 10px;
}

@media (max-width: 768px) {
  .responsive-filters {
    margin-bottom: 1rem;
  }

  .responsive-filters__content {
    padding: 0.75rem;
    background: #fff;
    border: 1px solid #e6edef;
    border-top: 0;
    border-radius: 0 0 10px 10px;
  }
}
</style>
